<template>
    <div>
        <div class="g-table-wrapper">
            <div class="table-title">
                {{ type }}
            </div>

            <vue-good-table
                :key="tableKey"
                :columns="columns"
                :rows="rows"
                :search-options="searchOptions"
                :pagination-options="paginationOptions"
                :sort-options="sortOptions"
                :styleClass="styleClass"
                @on-row-click="selectProjectType"
                :row-style-class="selectedRowClass"
            >
                <div slot="emptystate">
                    Ingen data ...
                </div>
                <template slot="table-row" slot-scope="props">
                    <div v-if="props.column.field == 'description'" class="table-column__description" :title="props.row.description">
                        {{ props.row.description }}
                    </div>
                    <div v-else-if="props.column.field == 'proposal_cost'" style="text-align:left;">
                        {{ props.row.proposal_cost | currency }}
                    </div>
                    <div v-else-if="props.column.field == 'expended_cost'" style="text-align:left;">
                        {{ props.row.expended_cost | currency }}
                    </div>
                    <div v-else-if="props.column.field == 'difference'" style="text-align:left;" :class="{'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0}">
                        <span v-if="(props.row.proposal_cost - props.row.expended_cost) > 0">+</span>{{ props.row.proposal_cost - props.row.expended_cost | currency }}
                    </div>
                    <div v-else-if="props.column.field == 'paid'" style="text-align:left;">
                        <span v-if="props.row.paid">
                            Betalt
                        </span>
                        <span v-else>
                            Ikke betalt
                        </span>
                    </div>
                    <div v-else-if="props.column.field == 'minuba_external_id'">
                        <a :href="'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id" target="_blank" class="minuba-link">
                            <i class="fas fa-eye"></i>
                        </a>
                    </div>
                    <div v-else :title="props.formattedRow[props.column.field]">
                        {{ props.formattedRow[props.column.field] }}
                    </div>
                </template>
            </vue-good-table>
        </div>

        <div style="margin-top:30px;">
            <div v-if="selectedProjectType">
                <minuba-budget-single-projects :rows="selectedProjectType.projects" :type="selectedProjectType.name"></minuba-budget-single-projects>
            </div>
            <div v-else>
                Vælg en opgavetype for at se de enkelte opgaver her
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: ['type', 'rows'],
        data () {
            return {
                tableKey: 0,
                selectedProjectType: null,
                columns: [
                    { label: 'Budgetlinje', field: 'name', type: 'string', width: '30%', align: 'left', sortable: true },
                    { label: 'Antal opgaver', field: 'projects_count', type: 'number', width: '10%', align: 'left', sortable: true },
                    { label: 'Budgetteret', field: 'proposal_cost', type: 'number', width: '20%', align: 'left', sortable: true },
                    { label: 'Realiseret', field: 'expended_cost', type: 'number', width: '20%', align: 'left', sortable: true },
                    { label: 'Difference', field: 'difference', type: 'number', width: '20%', align: 'left', sortable: true }
                ],
                searchOptions: {
                    enabled: true,
                    trigger: 'enter',
                    placeholder: 'Søg og tryk enter ...',
                    skipDiacritics: true
                },
                paginationOptions: {
                    enabled: true,
                    perPage: 30,
                    rowsPerPageLabel: 'Rækker pr. side',
                    allLabel: 'Alle',
                    nextLabel: 'Næste',
                    prevLabel: 'Forrige',
                    ofLabel: 'af',
                    pageLabel: 'side'
                },
                sortOptions: {
                    enabled: true,
                    initialSortBy: {
                        field: 'difference',
                        type: 'desc'
                    }
                },
                styleClass: 'vgt-table',
                params: {}
            }
        },
        methods: {
            selectProjectType (params) {
                this.selectedProjectType = params.row
                this.tableKey++
            },
            selectedRowClass (row) {
                if (this.selectedProjectType && this.selectedProjectType.name === row.name) {
                    return 'selected'
                }
                return ''
            }
        },
        watch: {
            rows: function () {
                this.selectedProjectType = null
                this.tableKey++
            }
        },
        components: {
            'minuba-budget-single-projects': require('./minubaBudgetSingleProjects.vue')
        }
    }
</script>

<style lang="scss" scoped>
@import "../../../styles/vars.scss";

    .good, .bad {
        font-weight: 700;
    }

    .good, .good span {
        color: $color--good !important;
    }

    .bad, .bad span {
        color: $color--bad !important;
    }

</style>



// WEBPACK FOOTER //
// minubaBudgetProjectTypesLineTypes.vue?5b9fd09f